var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import Flex from "@irati/ui/src/Flex";
import padding from "@irati/ui/src/global/padding";
import { Hr } from "@irati/ui/src/Layout";
import { RouterLink as BaseRouterLink } from "@irati/ui/src/Link";
export var AdminCard = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex-direction: column;\n  background-color: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  padding: ", ";\n  max-width: 49%;\n"], ["\n  flex-direction: column;\n  background-color: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  padding: ", ";\n  max-width: 49%;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.border.radius;
}, function (_a) {
    var theme = _a.theme;
    return theme.shadows.mid;
}, padding.small);
export var ButtonWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex-grow: 2;\n  & > :first-child {\n    margin-right: ", ";\n  }\n"], ["\n  flex-grow: 2;\n  & > :first-child {\n    margin-right: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.two;
});
export var ColorHr = styled(Hr)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border-color: ", ";\n"], ["\n  border-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.graphGrey;
});
export var MarginLeft = styled(BaseRouterLink)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-left: auto;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n"], ["\n  margin-left: auto;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n"])));
export var RouterLink = styled(BaseRouterLink)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  text-transform: none;\n  &:hover {\n    text-decoration: none;\n  }\n"], ["\n  text-transform: none;\n  &:hover {\n    text-decoration: none;\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
